import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';

const KNOWN_ERRORS = [/timeout of .+ exceeded/];

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Report errors with unknown status, including CORS errors
    if (
      !error.response?.status &&
      !axios.isCancel(error) &&
      !KNOWN_ERRORS.some((regex) => regex.test(error.message))
    ) {
      const baseURL = error.config?.url?.split('?')[0];

      const errorContext = {
        url: error.config?.url,
        baseURL,
        method: error.config?.method,
      };

      datadogRum.addError(new Error(`Unknown fetch error: ${baseURL}`), errorContext);
    }

    return Promise.reject(error);
  },
);
